"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParam = getParam;

var _urlencode = require("urlencode");

/**
 * Utility for query string parameters.
 */

/**
  * Returns the requested query parameter.
  * @param  {String} name Parameter's name
  * @return {String}      Parameter's value
  */
function getParam(name) {

  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var tmpURL = window.location.href;
  var results = regex.exec(tmpURL);

  return results === null ? "" : (0, _urlencode.decode)(results[1]);
}

exports.default = getParam;